import { createPortal } from 'react-dom';
import { useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import StravaConnect from './Widgets/StravaConnect';

export default function SyncModal({ isOpen, onClose }) {
  const { t } = useLanguage();
  const overlayRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      ref={overlayRef}
      className='fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-in fade-in duration-200'
      style={{ zIndex: 10000 }}
      onClick={(e) => {
        if (e.target === overlayRef.current) onClose();
      }}
    >
      <div
        className='bg-card border border-border rounded-xl shadow-2xl flex flex-col animate-in zoom-in-95 slide-in-from-bottom-4 duration-300 max-w-[90vw] w-[420px] max-h-[85vh] overflow-hidden'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='flex items-start justify-between gap-3 px-5 py-4 border-b border-border shrink-0'>
          <div className='min-w-0 pr-2'>
            <h2 className='text-base font-semibold text-foreground'>
              {t('strava.connectModalTitle')}
            </h2>
            <p className='text-sm text-muted-foreground mt-1'>
              {t('strava.connectModalSubtitle')}
            </p>
          </div>
          <Button variant='ghost' size='icon' className='h-8 w-8 shrink-0' onClick={onClose}>
            <X className='h-4 w-4' />
          </Button>
        </div>

        <div className='overflow-auto flex-1 min-h-0'>
          <StravaConnect
            suppressTopHeader
            config={{}}
            widget={{ name: t('strava.title'), widget_key: 'strava_connect' }}
          />
        </div>
      </div>
    </div>,
    document.body
  );
}
